// Indian date + currency formatting helpers.

export function formatDateDMY(value) {
  if (!value) return "-";
  // Accept DD-MM-YYYY as-is.
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) return value;
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function shiftInfo(start, end) {
  const p = (t) => { const m = /^(\d{1,2}):(\d{2})$/.exec(t || ""); return m ? +m[1] * 60 + +m[2] : null; };
  const s = p(start), e = p(end);
  if (s === null || e === null) return null;
  const mins = (e - s + 1440) % 1440 || 1440;
  const hours = Math.round((mins / 60) * 10) / 10;
  return { hours, overnight: e <= s, label: `${hours}h${e <= s ? " · ends next day" : ""}` };
}

export function formatTime12(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm || "");
  if (!m) return hhmm || "";
  const h = +m[1];
  return `${h % 12 || 12}:${m[2]} ${h >= 12 ? "PM" : "AM"}`;
}

export function formatDateTimeIST(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function formatINR(num) {
  if (num == null || num === "") return "₹0";
  const n = Number(num);
  if (isNaN(n)) return "₹0";
  return "₹" + n.toLocaleString("en-IN");
}
